import { PageMeta } from "../components/PageMeta";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { WorldMap } from "../components/WorldMap";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../data/content";

export default function GlobalReach() {
  const { t } = useLanguage();
  const markets = t("markets");
  const destMarkets = t("reach.destMarkets");

  return (
    <main>
      <PageMeta
        title="Global Reach | International Food Trading Company – Al Nama Importer"
        description="Al Nama Importer operates as an international bridge between food-producing regions and global buyers — sourcing across Asia and the USA, supplying the UAE, Africa and beyond."
        titleAr="الانتشار العالمي | شركة تجارة غذائية دولية – النعم للاستيراد"
        descriptionAr="تعمل النعم للاستيراد كجسر دولي بين المناطق المنتجة للغذاء والمشترين العالميين — توريد من آسيا والولايات المتحدة، وتوريد إلى الإمارات وأفريقيا وما وراءها."
      />
      <PageHero
        image={IMAGES.dubaiSkyline}
        overline={t("reach.heroOver")}
        titleLines={[t("reach.heroL1"), t("reach.heroL2")]}
        text={t("reach.heroText")}
      />

      <section className="bg-[#09121F] py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <div className="overflow-hidden rounded-xl border border-amber-500/20 bg-[#0B1D16]/70 p-4 shadow-2xl sm:p-8">
              <WorldMap />
              <div className="mt-4 flex flex-wrap items-center justify-center gap-8 border-t border-amber-500/10 pt-5">
                <span className="flex items-center gap-2.5 text-xs uppercase tracking-[0.2em] text-slate-400">
                  <span className="h-2.5 w-2.5 rounded-full bg-[#D4AF37]" /> {t("reach.legendSrc")}
                </span>
                <span className="flex items-center gap-2.5 text-xs uppercase tracking-[0.2em] text-slate-400">
                  <span className="h-2.5 w-2.5 rounded-full bg-[#DFB756] ring-4 ring-[#DFB756]/20" /> {t("reach.legendHub")}
                </span>
                <span className="flex items-center gap-2.5 text-xs uppercase tracking-[0.2em] text-slate-400">
                  <span className="h-2.5 w-2.5 rounded-full bg-[#8FC1A9]" /> {t("reach.legendDst")}
                </span>
              </div>
            </div>
          </Reveal>

          <div className="mt-20 grid grid-cols-1 gap-6 lg:grid-cols-2">
            <Reveal>
              <div data-testid="sourcing-markets-panel" className="h-full rounded-lg border border-amber-500/20 bg-[#0F1E18]/60 p-8 sm:p-10">
                <p className="text-xs uppercase tracking-[0.28em] font-display font-semibold text-amber-400">
                  {t("reach.srcOver")}
                </p>
                <h3 className="mt-3 font-serif text-2xl font-semibold text-emerald-50">
                  {t("reach.srcTitle")}
                </h3>
                <ul className="mt-7 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
                  {markets.map((m) => (
                    <li key={m} className="flex items-center gap-3 text-sm text-slate-300/85">
                      <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" />
                      {m}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
            <Reveal delay={0.12}>
              <div data-testid="export-markets-panel" className="h-full rounded-lg border border-[#8FC1A9]/20 bg-[#0F1E18]/60 p-8 sm:p-10">
                <p className="text-xs uppercase tracking-[0.28em] font-display font-semibold text-[#8FC1A9]">
                  {t("reach.dstOver")}
                </p>
                <h3 className="mt-3 font-serif text-2xl font-semibold text-emerald-50">
                  {t("reach.dstTitle")}
                </h3>
                <ul className="mt-7 space-y-4">
                  {destMarkets.map((m) => (
                    <li key={m} className="flex items-center gap-3 text-sm text-slate-300/85">
                      <span className="h-1.5 w-1.5 rotate-45 bg-[#8FC1A9]" />
                      {m}
                    </li>
                  ))}
                </ul>
                <p className="mt-8 border-t border-amber-500/10 pt-6 text-sm font-light leading-relaxed text-slate-400">
                  {t("reach.dstText")}
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
